/** The Office callback style as a promise, so Office calls can be awaited and sequenced. */
export function fromOffice<T>(
  call: (callback: (result: Office.AsyncResult<T>) => void) => void
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    call((result: Office.AsyncResult<T>): void => {
      if (result.status !== Office.AsyncResultStatus.Succeeded) {
        reject(new Error(result.error?.message ?? 'The Office call failed'));
        return;
      }

      resolve(result.value);
    });
  });
}
